import { resetTimeout } from '../../utils/wait';
import { PaymentActionRequiredError } from '../Errors/customErrors';

import { getIsClosed, getIsExpired } from './QrisVariables';

export const validateQRModalIsExpired = () => {
  if (getIsClosed() && getIsExpired()) {
    throw new PaymentActionRequiredError(
      'QRIS is expired and user closed the modal',
      'IdQr',
    );
  }
};

export const validateQRModalIsClosed = () => {
  if (getIsClosed()) {
    resetTimeout();
    throw new PaymentActionRequiredError('User closed the modal', 'IdQr');
  }
};
